import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const DASHBOARD_API_URL = "agency/admin/dashboard-stats/";
const DASHBOARD_OVERVIEW_API_URL = "agency/admin/report-overview/";
const DASHBOARD_SUPERVISOR_Chart_OVERVIEW_API_URL =
  "agency/admin/supervisor-report/";

const AGENCY_ADMIN_TEAMLEAD_REPORT_API_URL = "agency/admin/teamlead-report/";
const PERFORMANCE_REPORT_API_URL = "api/telecaller-performance-data/";

export const fetchDashboard = createAsyncThunk(
  "agency/fetchDashboard",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
       const validUser = state.auth.user;
     if (!token || !validUser?.is_agency) {
        return;
      }

      const queryParams = { ...params };

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(',');
        delete queryParams.portfolios; // remove original array
      }
      if (Array.isArray(params?.states) && params?.states.length > 0) {
        queryParams.state = params.states.join(',');
        delete queryParams.states; // remove original array
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(',');
      }


      const response = await axios.get(DASHBOARD_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);
export const fetchDashboardOverview = createAsyncThunk(
  "agency/fetchDashboardOverview",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
        const validUser = state.auth.user;
     if (!token || !validUser?.is_agency) {
        return;
      }
      const queryParams = { ...params };

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(',');
        delete queryParams.portfolios; // remove original array
      }

      if (Array.isArray(params?.states) && params?.states.length > 0) {
        queryParams.state = params.states.join(',');
        delete queryParams.states; // remove original array
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(',');
      }

      const response = await axios.get(DASHBOARD_OVERVIEW_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);
export const fetchSupervisorReportOverview = createAsyncThunk(
  "agency/fetchSupervisorReportOverview",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
        const validUser = state.auth.user;
     if (!token || !validUser?.is_agency) {
        return;
      }

      const queryParams = { ...params };

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(',');
        delete queryParams.portfolios; // remove original array
      }

      if (Array.isArray(params?.states) && params?.states.length > 0) {
        queryParams.state = params.states.join(',');
        delete queryParams.states; // remove original array
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(',');
      }

      const response = await axios.get(
        DASHBOARD_SUPERVISOR_Chart_OVERVIEW_API_URL,
        {
          params: queryParams,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);
export const fetchTeamleadOverview = createAsyncThunk(
  "agency/fetchTeamleadOverview",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      const query = state.filters.query;
        const validUser = state.auth.user;
     if (!token || !validUser?.is_agency) {
        return;
      }

      const queryParams = { ...params };

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(',');
        delete queryParams.portfolios; // remove original array
      }

      if (Array.isArray(params?.states) && params?.states.length > 0) {
        queryParams.state = params.states.join(',');
        delete queryParams.states; // remove original array
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(',');
      }

      const response = await axios.get(AGENCY_ADMIN_TEAMLEAD_REPORT_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);

export const fetchPerformanceReportTable = createAsyncThunk(
  "agency/fetchPerformanceReportTable",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      const validUser = state.auth.user;
      const query = state.filters.query;
      if (!token || !validUser?.is_agency) {
        return;
      }

      const queryParams = { ...params };

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(',');
        delete queryParams.portfolios; // remove original array
      }

      if (Array.isArray(params?.states) && params?.states.length > 0) {
        queryParams.state = params.states.join(',');
        delete queryParams.states; // remove original array
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(',');
      }

      const response = await axios.get(PERFORMANCE_REPORT_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);



const initialState = {
  data: [],
  error: false,
  loading: false,
  overview: [],
  overviewLoading: false,
  overviewError: false,
  supervisorReportCoverageChart: [],
  supervisorReportLoading: false,
  team_lead_loading: false,
  teamLeadOverviewChart: [],
  performance_report_table: [],
  performance_report_table_loading: false,
};
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
        state.data = [];
      })
      .addCase(fetchDashboardOverview.pending, (state) => {
        state.overviewLoading = true;
        state.overviewError = null;
      })
      .addCase(fetchDashboardOverview.fulfilled, (state, action) => {
        state.overviewLoading = false;
        state.overview = action.payload;
      })
      .addCase(fetchDashboardOverview.rejected, (state, action) => {
        state.overviewLoading = false;
        state.overviewError = action.payload || "Something went wrong";
        state.overview = [];
      })

      // supervisor report overview
      .addCase(fetchSupervisorReportOverview.pending, (state) => {
        state.supervisorReportLoading = true;
        state.overviewError = null;
      })
      .addCase(fetchSupervisorReportOverview.fulfilled, (state, action) => {
        state.supervisorReportLoading = false;
        state.supervisorReportCoverageChart = action.payload;
      })
      .addCase(fetchSupervisorReportOverview.rejected, (state, action) => {
        state.supervisorReportLoading = false;
        state.overviewError = action.payload || "Something went wrong";
        state.supervisorReportCoverageChart = [];
      })

      // team lead overview
      .addCase(fetchTeamleadOverview.pending, (state) => {
        state.team_lead_loading = true;
        state.overviewError = null;
      })
      .addCase(fetchTeamleadOverview.fulfilled, (state, action) => {
        state.team_lead_loading = false;
        state.teamLeadOverviewChart = action.payload;
      })
      .addCase(fetchTeamleadOverview.rejected, (state, action) => {
        state.team_lead_loading = false;
        state.overviewError = action.payload || "Something went wrong";
        state.teamLeadOverviewChart = [];
      })

      // performance report table
      .addCase(fetchPerformanceReportTable.pending, (state) => {
        state.performance_report_table_loading = true;

      })
      .addCase(fetchPerformanceReportTable.fulfilled, (state, action) => {
        state.performance_report_table_loading = false;
        state.performance_report_table = action.payload;
      })
      .addCase(fetchPerformanceReportTable.rejected, (state, action) => {
        state.performance_report_table_loading = false;

        state.performance_report_table = [];
      });
  },
});

export default dashboardSlice.reducer;
